import React from 'react';

export default function AbstractCenterIcon({ width = 28, height = 28, fill = '#D1B2B2' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.005 16.1349C10.2637 15.8225 10.0671 15.3482 9.663 15.31L1.12403 14.5022C0.513198 14.4445 0.513409 13.5539 1.12427 13.4964L9.66277 12.6927C10.0669 12.6547 10.2637 12.1804 10.0051 11.8679L4.52835 5.25125C4.13747 4.77902 4.76767 4.14957 5.24036 4.54008L11.86 10.0089C12.1728 10.2673 12.6475 10.0709 12.6858 9.66725L13.4959 1.12451C13.5538 0.514488 14.4449 0.514488 14.5028 1.12451L15.3129 9.66725C15.3512 10.0709 15.8259 10.2673 16.1387 10.0089L22.7583 4.54008C23.231 4.14957 23.8612 4.77902 23.4704 5.25125L17.9936 11.8679C17.735 12.1804 17.9318 12.6547 18.3359 12.6927L26.8744 13.4964C27.4853 13.5539 27.4855 14.4445 26.8747 14.5022L18.3357 15.31C17.9316 15.3482 17.735 15.8225 17.9937 16.1349L23.4636 22.7393C23.8547 23.2115 23.2245 23.8412 22.7517 23.4506L16.1387 17.9873C15.8259 17.7289 15.3512 17.9253 15.313 18.3289L14.5028 26.8761C14.445 27.4862 13.5537 27.4862 13.4959 26.8761L12.6857 18.3289C12.6475 17.9253 12.1728 17.7289 11.86 17.9873L5.24698 23.4506C4.77422 23.8411 4.14399 23.2115 4.53507 22.7393L10.005 16.1349Z"
        fill={fill}
      />
    </svg>
  );
}
